<template>
    <grid-area area="bar">
        <navigation-bar>
            <template v-if="false" #search>
                <navigation-bar-item-search />
            </template>

            <template #default>
                <navigation-bar-item
                    :icon="LeaderboardIcon"
                    :href="createLegacyUrl('leaderboard')"
                    label="Leaderboard"
                />

                <navigation-bar-item
                    v-if="currentUser?.role.equals(Role.COMPANY_MANAGER)"
                    :icon="SettingsIcon"
                    :href="createLegacyUrl('company/settings')"
                    label="Settings"
                />

                <collapse-box-decorator
                    trigger="hover"
                    horizontal-position="right"
                >
                    <template #default="{ bindings }">
                        <user-avatar
                            v-bind="bindings"
                            :placeholder="currentUser?.name.abbreviation ?? ''"
                            size="xl"
                            :url="currentUser?.avatar ? resizedToSizeUploadUrl(currentUser?.avatar, 'xl') : ''"
                            :alt="currentUser?.name"
                        />
                    </template>

                    <template #content>
                        <collapse-option-container>
                            <collapse-option @click="redirectToLegacyUrl('user/settings')">
                                Profiel
                            </collapse-option>
                            <collapse-option v-if="currentUser?.superAdmin" @click="redirectToLegacyUrl('license')">
                                Licentie Beheer
                            </collapse-option>
                            <collapse-option @click="confirmLogout">
                                Uitloggen
                            </collapse-option>
                        </collapse-option-container>
                    </template>
                </collapse-box-decorator>

                <confirmation-dialog
                    ref="logoutConfirmDialog"
                    label="Uitloggen"
                    description="Weet je zeker dat je wilt uitloggen?"
                >
                    <template #actions="{ bindings }">
                        <button-outline @click="bindings.overlay.closeOverlay();">
                            Annuleren
                        </button-outline>
                        <button-block @loading="logout">
                            Uitloggen
                        </button-block>
                    </template>
                </confirmation-dialog>
            </template>
        </navigation-bar>
    </grid-area>
</template>

<script setup lang="ts">
    import {
        ButtonBlock,
        ButtonOutline,
        CollapseBoxDecorator,
        CollapseOptionContainer,
        CollapseOption,
        ConfirmationDialog,
        type ExposedOverlay,
        GridArea,
        NavigationBar,
        NavigationBarItem,
        UserAvatar,
    } from '@keyvue/one-ui';

    import LeaderboardIcon from '@keyvue/one-material-icons/icons/leaderboard.svg?component';
    import SettingsIcon from '@keyvue/one-material-icons/icons/settings.svg?component';
    import NavigationBarItemSearch from '@components/Navigation/NavigationBarItemSearch.vue';
    import createLegacyUrl from '@/utils/legacyUrls';
    import { resizedToSizeUploadUrl } from '@/utils/resize';
    import useClient from '@composables/useClient';
    import { Role } from '@keyvue/one-api-client';
    import { ref } from 'vue';

    const { client, currentUser } = useClient();

    const redirectToLegacyUrl = (path: string) => {
        window.location.href = createLegacyUrl(path);
    };

    const logoutConfirmDialog = ref<ExposedOverlay>();

    const confirmLogout = () => {
        logoutConfirmDialog.value?.openOverlay();
    };

    const logout = async () => {
        await client.logout();

        redirectToLegacyUrl('logout');
    };
</script>
